export default __webpack_public_path__ + "static/media/logo.6c7a771d.jpg";